import { JsonUtils } from '../../utils/json.util'
import PatientMetricsStatisticsGroup from './patient.metrics.statistics.group'

export default class PatientMetricsStatistics {
    private _id: string | undefined
    private _created_at: string | undefined
    private _updated_at: string | undefined
    private _start_date: string | undefined
    private _end_date: string | undefined
    private _gender_profile: PatientMetricsStatisticsGroup[] | undefined
    private _steps_avg: number | undefined
    private _active_minutes_avg: number | undefined
    private _sleep_hours_avg: number | undefined
    private _daily_usage_time_avg: number | undefined
    private _sleep_efficiency_avg: number | undefined
    private _device_replacement_percentage: number | undefined
    private _active_patients_profile: PatientMetricsStatisticsGroup[] | undefined
    private _healthprofessional_id: string | undefined
    private _healthprofessional_name: string | undefined

    get id(): string | undefined {
        return this._id
    }

    set id(value: string | undefined) {
        this._id = value
    }

    get created_at(): string | undefined {
        return this._created_at
    }

    set created_at(value: string | undefined) {
        this._created_at = value
    }

    get updated_at(): string | undefined {
        return this._updated_at
    }

    set updated_at(value: string | undefined) {
        this._updated_at = value
    }

    get start_date(): string | undefined {
        return this._start_date
    }

    set start_date(value: string | undefined) {
        this._start_date = value
    }

    get end_date(): string | undefined {
        return this._end_date
    }

    set end_date(value: string | undefined) {
        this._end_date = value
    }

    get gender_profile(): PatientMetricsStatisticsGroup[] | undefined {
        return this._gender_profile
    }

    set gender_profile(value: PatientMetricsStatisticsGroup[] | undefined) {
        this._gender_profile = value
    }

    get steps_avg(): number | undefined {
        return this._steps_avg
    }

    set steps_avg(value: number | undefined) {
        this._steps_avg = value
    }

    get active_minutes_avg(): number | undefined {
        return this._active_minutes_avg
    }

    set active_minutes_avg(value: number | undefined) {
        this._active_minutes_avg = value
    }

    get sleep_hours_avg(): number | undefined {
        return this._sleep_hours_avg
    }

    set sleep_hours_avg(value: number | undefined) {
        this._sleep_hours_avg = value
    }

    get daily_usage_time_avg(): number | undefined {
        return this._daily_usage_time_avg
    }

    set daily_usage_time_avg(value: number | undefined) {
        this._daily_usage_time_avg = value
    }

    get sleep_efficiency_avg(): number | undefined {
        return this._sleep_efficiency_avg
    }

    set sleep_efficiency_avg(value: number | undefined) {
        this._sleep_efficiency_avg = value
    }

    get device_replacement_percentage(): number | undefined {
        return this._device_replacement_percentage
    }

    set device_replacement_percentage(value: number | undefined) {
        this._device_replacement_percentage = value
    }

    get active_patients_profile(): PatientMetricsStatisticsGroup[] | undefined {
        return this._active_patients_profile
    }

    set active_patients_profile(value: PatientMetricsStatisticsGroup[] | undefined) {
        this._active_patients_profile = value
    }

    get healthprofessional_id(): string | undefined {
        return this._healthprofessional_id
    }

    set healthprofessional_id(value: string | undefined) {
        this._healthprofessional_id = value
    }

    get healthprofessional_name(): string | undefined {
        return this._healthprofessional_name
    }

    set healthprofessional_name(value: string | undefined) {
        this._healthprofessional_name = value
    }

    public fromJSON(json: any): PatientMetricsStatistics {
        if (!json) {
            return this
        }

        if (typeof json === 'string') {
            if (!JsonUtils.isJsonString(json)) {
                return this
            }
            json = JSON.parse(json)
        }

        if (json.id !== undefined) {
            this.id = json.id
        }

        if (json.created_at !== undefined) {
            this.created_at = json.created_at
        }

        if (json.updated_at !== undefined) {
            this.updated_at = json.updated_at
        }

        if (json.start_date !== undefined) {
            this.start_date = json.start_date
        }

        if (json.end_date !== undefined) {
            this.end_date = json.end_date
        }

        if (json.gender_profile?.length) {
            this.gender_profile = json
                ?.gender_profile
                ?.map((item: any) => new PatientMetricsStatisticsGroup().fromJSON(item)) || []
        }

        if (json.steps_avg !== undefined) {
            this.steps_avg = parseFloat(`${Number(json.steps_avg).toFixed(2)}`)
        }

        if (json.active_minutes_avg !== undefined) {
            this.active_minutes_avg = parseFloat(`${Number(json.active_minutes_avg).toFixed(2)}`)
        }

        if (json.sleep_hours_avg !== undefined) {
            this.sleep_hours_avg = parseFloat(`${Number(json.sleep_hours_avg).toFixed(2)}`)
        }

        if (json.daily_usage_time_avg !== undefined) {
            this.daily_usage_time_avg = Number(json.daily_usage_time_avg)
        }

        if (json.sleep_efficiency_avg !== undefined) {
            this.sleep_efficiency_avg = Number(json.sleep_efficiency_avg)
        }

        if (json.device_replacement_percentage !== undefined) {
            this.device_replacement_percentage = Number(json.device_replacement_percentage)
        }

        if (json.active_patients_profile.length) {
            this.active_patients_profile = json
                ?.active_patients_profile
                ?.map((item: any) => new PatientMetricsStatisticsGroup().fromJSON(item)) || []
        }

        if (json.healthprofessional_id !== undefined) {
            this.healthprofessional_id = json.healthprofessional_id
        }

        if (json.healthprofessional_name !== undefined) {
            this.healthprofessional_name = json.healthprofessional_name
        }

        return this
    }

    public toJSON(): any {
        return {
            id: this.id ? this.id : undefined,
            created_at: this.created_at ? this.created_at : undefined,
            updated_at: this.updated_at ? this.created_at : undefined,
            start_date: this.start_date ? this.start_date : undefined,
            end_date: this.end_date ? this.end_date : undefined,
            gender_profile: this.gender_profile
                ?.map((genderMetric: PatientMetricsStatisticsGroup) => genderMetric.toJSON()) || [],
            steps_avg: this.steps_avg ? this.steps_avg : undefined,
            active_minutes_avg: this.active_minutes_avg ? this.active_minutes_avg : undefined,
            sleep_hours_avg: this.sleep_hours_avg ? this.sleep_hours_avg : undefined,
            daily_usage_time_avg: this.daily_usage_time_avg ? this.daily_usage_time_avg : undefined,
            sleep_efficiency_avg: this.sleep_efficiency_avg ? this.sleep_efficiency_avg : undefined,
            device_replacement_percentage: this.device_replacement_percentage ? this.device_replacement_percentage : undefined,
            active_patients_profile: this.active_patients_profile
                ?.map((profileItem: PatientMetricsStatisticsGroup) => profileItem.toJSON()) || [],
            healthprofessional_id: this.healthprofessional_id ? this.healthprofessional_id : undefined,
            healthprofessional_name: this.healthprofessional_name ? this.healthprofessional_name : undefined
        }
    }
}
